/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { arrivalsOrderSchema } from "./arrivalsOrderSchema.ts";

export const orderArrivalsListQueryOrgUnitSchema = z.uuid();

export const orderArrivalsListStatus200Schema = z.array(arrivalsOrderSchema);

export const orderArrivalsListResponseSchema = orderArrivalsListStatus200Schema;
